import * as React from 'react'
import { styled } from 'next-yak'

import { RoleTag } from './tag/RoleTag'

import * as S from '../styles'
import { type RoleTagColors } from '../styles/tag'

type ContentProps = {
  avatar?: string
  avatarSize?: 'extra-small' | 'small' | 'medium' | 'large' | 'extra-large'
  name?: React.ReactNode
  tag?: Tag
}

export type UserLabelProps = {
  isPublic: boolean
  className?: string
  href?: string
} & React.ComponentPropsWithoutRef<'div'> &
  ContentProps &
  React.AnchorHTMLAttributes<HTMLAnchorElement>

type Tag = {
  backgroundColor?: RoleTagColors
  label: string
}

function UserLabelComponent({
  avatar,
  avatarSize,
  className,
  href,
  isPublic,
  name,
  tag,
  ...rest
}: UserLabelProps): React.ReactElement<UserLabelProps> {
  return (
    <>
      {isPublic ? (
        <>
          {!!name ? (
            <S.userLabel.UserLabelLinkWithLabel href={href} className={className} {...rest}>
              <Content avatar={avatar} avatarSize={avatarSize} name={name} tag={tag} />
            </S.userLabel.UserLabelLinkWithLabel>
          ) : (
            <S.userLabel.UserLabelLink href={href} className={className} {...rest}>
              <Content avatar={avatar} avatarSize={avatarSize} name={name} tag={tag} />
            </S.userLabel.UserLabelLink>
          )}
        </>
      ) : (
        <>
          {!!name ? (
            <S.userLabel.UserLabelWithLabel className={className} {...rest}>
              <Content avatar={avatar} avatarSize={avatarSize} name={name} tag={tag} />
            </S.userLabel.UserLabelWithLabel>
          ) : (
            <S.userLabel.UserLabel className={className} {...rest}>
              <Content avatar={avatar} avatarSize={avatarSize} name={name} tag={tag} />
            </S.userLabel.UserLabel>
          )}
        </>
      )}
    </>
  )
}

function Content({ avatar, avatarSize, name, tag }: ContentProps) {
  return (
    <>
      {avatar && <S.image.Avatar src={avatar} type={avatarSize} />}
      {name && (
        <>
          {name} {tag && <RoleTag backgroundColor={tag.backgroundColor}>{tag.label}</RoleTag>}
        </>
      )}
    </>
  )
}

export const UserLabel = styled(UserLabelComponent)<UserLabelProps>``
UserLabel.displayName = 'UserLabel'
